module.exports = __webpack_public_path__ + "static/basics-3683ccb02ebc8cd9e9561f86e0772067.png";